// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<div style="height: 100%">
  <v-toolbar dark dense class="obspanel-toolbar">
    <v-btn icon @click.stop.native="back">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
  </v-toolbar>

  <v-container fluid style="height: 100%">
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="text-h5 mb-0">Sign in to NoctuaSky</h3>
        </div>
      </v-card-title>
      <v-progress-circular v-if="signInInProgress" indeterminate v-bind:size="50" style="position: absolute; left: 0; right: 0; margin-left: auto; margin-right: auto; margin-top: 60px;"></v-progress-circular>
      <v-card-text>
        <form action="">
          <v-text-field :disabled="signInInProgress" name="email" label="Email" autocomplete="email" v-model="email" @input="clearSignInErrorAlert" type="email"></v-text-field>
          <v-text-field :disabled="signInInProgress" name="password" label="Password" autocomplete="current-password" v-model="password" type="password" @keyup.native.enter="signIn()" @input="clearSignInErrorAlert"></v-text-field>
          <v-alert error v-model="showSignInErrorAlert">{{ signInErrorAlert }}</v-alert>
          <v-row justify="space-around">
            <v-btn color="green" @click.stop.native="signIn()" :disabled="signInButtonDisabled || signInInProgress">Sign In</v-btn>
          </v-row>
        </form>
      </v-card-text>
      <v-row justify="space-around">
        <router-link to="/p/users/forgot-password">Forgot your password ?</router-link>
      </v-row>
      <v-card-actions>
      </v-card-actions>
    </v-card>
    <v-row justify="space-around" style="margin-top: 30px">
      <p>New to NoctuaSky? <v-btn text small to="/p/users/signup">Create an account</v-btn></p>
    </v-row>
  </v-container>

</div>
</template>

<script>

import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      email: '',
      password: '',
      signInErrorAlert: '',

      rules: {
        email: (value) => {
          if (value === '') {
            return true
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        password: (value) => {
          if (value === '') {
            return true
          }
          if (value.length < 8) {
            return 'Use at least 8 characters'
          }
          return true
        }
      }
    }
  },
  methods: {
    signIn: function () {
      var that = this
      NoctuaSkyClient.users.login(this.email, this.password).then(function (res) { that.back() }, function (res) {
        if (res.message) {
          that.signInErrorAlert = res.message
        } else if (res.errors) {
          that.signInErrorAlert = ''
          for (const k in res.errors) {
            that.signInErrorAlert += k + ': ' + res.errors[k] + '\n'
          }
        }
      })
    },
    clearSignInErrorAlert: function () {
      this.signInErrorAlert = ''
    },
    back: function () {
      this.$router.replace('/p')
    }
  },
  computed: {
    signInButtonDisabled: function () {
      return this.email === '' || this.password === ''
    },
    signInInProgress: function () {
      return this.$store.state.noctuaSky.status === 'signInInProgress'
    },
    showSignInErrorAlert: function () {
      return this.signInErrorAlert !== ''
    }
  }
}
</script>

<style>
</style>
